export const TEAM = 'team';
export const GROUP = 'group';
export const COMPANY = 'company';

export const SUPPORTED_ADMIN_BADGE_ROLES = [
  'isLead',
  'isAnalyst',
  'isEditor',
  'isManager',
];
